import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { useAuth0 } from '@auth0/auth0-react'
import { useAppState, useAppDispatch } from 'Context/AppContext/AppContext'
import ProgressBar from 'Components/Views/AppBar/ProgressBar/ProgressBar'
import { Box } from '@material-ui/core/'
import MaterialIconSong from 'Components/SongComponents/MaterialIconSong/MaterialIconSong'
import useConfigureActivePlans from 'Hooks/useConfigureActivePlans/useConfigureActivePlans'
import { useDetectAdBlock } from 'adblock-detect-react'
import { UPDATE_ADBLOCKER_DETECTED } from 'TypeDefs/AppContext'
import useStyles from './AppBar.styles'

const ButtonAppBar = () => {
  const classes = useStyles()
  const { isAuthenticated } = useAuth0()
  const state = useAppState()
  const appBarWidth = isAuthenticated ? classes.appBar : classes.appBarLoggedOut
  const { isFunderUser } = useConfigureActivePlans()
  const detectedAdblock = useDetectAdBlock()
  const dispatch = useAppDispatch()

  const {
    ui: {
      appBar: { linearProgress, displayLinearProgress, header },
    },
  } = state

  React.useEffect(() => {
    if (detectedAdblock) {
      dispatch({
        type: UPDATE_ADBLOCKER_DETECTED,
        adblockerDetected: true,
      })
    }
  }, [detectedAdblock, dispatch])

  if (!isFunderUser) {
    return displayLinearProgress ? (
      <Box>
        <AppBar className={appBarWidth}>
          <Toolbar className={classes.toolBar}>
            <Box display='flex'>
              <MaterialIconSong icon={header.iconName} />
              <Typography variant='h5' className={classes.header}>
                {header.text}
              </Typography>
            </Box>
          </Toolbar>
          <ProgressBar progress={linearProgress} />
        </AppBar>
      </Box>
    ) : (
      <></>
    )
  }
  return <></>
}

export default ButtonAppBar
